var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconAllergies = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#525254",
  fillRule: "nonzero",
  d: "M10 0a2.99 2.99 0 0 0-2.816 2H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-4.184A2.99 2.99 0 0 0 10 0m0 2a1 1 0 0 1 .389 1.922L10 4l-.389-.078A1.002 1.002 0 0 1 10 2M3 4h2v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4h2v14H3zm6 4v2.246L7.068 9.102l-1.02 1.72L8.039 12l-1.99 1.178 1.02 1.72L9 13.754V16h2v-2.246l1.932 1.144 1.02-1.72L11.961 12l1.99-1.178-1.02-1.72L11 10.246V8z"
}))));
export default SvgIconAllergies;